<template>
  <ol
    id="log-listing"
    class="list-reset mt-4"
  >
    <li
      v-if="completed"
      class="mb-4"
    >
      <div
        class="relative border border-neutral-200 bg-neutral-100 text-neutral-800 px-6 py-2 uppercase font-bold text-xs text-center"
      >
        Project Closed
      </div>
    </li>
    <li
      v-if="!log.length"
      class="mb-4"
    >
      <div
        class="relative border border-primary-200 bg-primary-100 text-primary-800 px-6 py-2 uppercase font-bold text-xs text-center"
      >
        You have not requested any changes
      </div>
    </li>
    <slide-y-down-transition group>
      <log-listing-item
        v-for="item in log"
        :key="item.id"
        :item="item"
      />
    </slide-y-down-transition>
  </ol>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";
export default {
  name: "LogListing",
  components: {
    SlideYDownTransition
  },
  props: {
    completed: {
      type: Boolean,
      required: false,
      default: false
    },
    log: {
      type: Array,
      required: true
    }
  }
};
</script>
